import { Box, Button, LinearProgress, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface PaginationProps {
  loadedArticleCount: number;
  totalArticleCount: number;
  hasNextPage?: boolean;
  fetchNextPage?: () => void;
}

export default function Pagination({
  loadedArticleCount,
  totalArticleCount,
  hasNextPage = false,
  fetchNextPage = () => {},
}: Readonly<PaginationProps>) {
  const { t } = useTranslation();

  return (
    <Box>
      {loadedArticleCount < totalArticleCount && (
        <LinearProgress
          variant='determinate'
          color='primary'
          value={(loadedArticleCount / totalArticleCount) * 100}
          sx={{ marginBottom: 1 }}
          aria-label={`${t('articles.title')} 1–${loadedArticleCount} ${t('articles.outOfTotalCount', { count: totalArticleCount })}`}
        />
      )}
      <Stack
        direction='column'
        useFlexGap
        sx={{
          gap: 3,
          alignItems: 'center',
          justifyContent: 'flex-end',
          paddingBottom: 6,
        }}
      >
        <Typography variant='body2'>
          {t('articles.title')}{' '}
          <Typography component='span' variant='body2' sx={{ fontWeight: 700 }}>
            1–{loadedArticleCount}
          </Typography>{' '}
          {t('articles.outOfTotalCount', { count: totalArticleCount })}
        </Typography>
        {hasNextPage && (
          <Button
            variant='outlined'
            sx={{ whiteSpace: 'nowrap' }}
            onClick={() => fetchNextPage()}
          >
            {t('articles.showMore')}
          </Button>
        )}
        {!hasNextPage && (
          <Typography variant='subtitle1'>
            {t('articles.allContentLoaded')}
          </Typography>
        )}
      </Stack>
    </Box>
  );
}
